import React from 'react';
import PdfViewer from '../components/PdfViewer';
import './WeekScheduleKids.css';
import './Loader.css';

function WeekScheduleKids() {
    var timestamp = new Date().getTime();
    var jennyurl = `https://kvalstadfamlylifestorage.blob.core.windows.net/jennystorage/ukeplan.pdf?t=${timestamp}`;

    var siverturl = `https://kvalstadfamlylifestorage.blob.core.windows.net/sivertstorage/ukeplan.pdf?t=${timestamp}`;

    return (
        <div className="weekschedulekidsgrid-container">
            <div className="weekschedulekidsgrid-item weekschedulekidsgrid-item1" id="sivertUkeplanId">
                <PdfViewer parentId="jennyUkeplanId" file={jennyurl} />
            </div>
            <div className="weekschedulekidsgrid-item weekschedulekidsgrid-item2" id="jennyUkeplanId">
                <PdfViewer parentId="sivertUkeplanId" file={siverturl} />
            </div>
        </div>
    );
}

export default WeekScheduleKids;